export const PaginationConfig = {
  perPage: 25,
  page: 1,
  pageSizeOptions: [5, 10, 25, 100],
};
